import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Fade, makeStyles } from '@material-ui/core';
import Extension from './extension';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
  },
  extension: {
    display: 'flex',
    maxWidth: '100%',
    marginLeft: spacing(2),
  },
}));

const Extensions = ({
  translations,
  extensions = [],
  typeUsersCount,
  onEdit,
  onDelete,
  onGetUsers,
  onRemoveUsers,
  canAccessUserProfileCheck,
  onGoToProfilePage,
  onAddExtensionUsers,
}) => {
  const classes = useStyles();

  return (
    <TransitionGroup className={classes.root}>
      {extensions.map(extension => (
        <Fade key={`extension_${extension.id}`} in unmountOnExit>
          <div className={classes.extension}>
            <Extension
              translations={translations}
              extension={extension}
              typeUsersCount={typeUsersCount}
              onEdit={onEdit}
              onDelete={onDelete}
              onGetUsers={onGetUsers(extension.id)}
              onRemoveUsers={onRemoveUsers(extension)}
              canAccessUserProfileCheck={canAccessUserProfileCheck}
              onGoToProfilePage={onGoToProfilePage}
              onAddUsers={onAddExtensionUsers}
            />
          </div>
        </Fade>
      ))}
    </TransitionGroup>
  );
};

Extensions.propTypes = {
  translations: PropTypes.object.isRequired,
  extensions: PropTypes.arrayOf(PropTypes.object),
  typeUsersCount: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onGetUsers: PropTypes.func.isRequired,
  onRemoveUsers: PropTypes.func.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onGoToProfilePage: PropTypes.func.isRequired,
  onAddExtensionUsers: PropTypes.func.isRequired,
};

export default Extensions;
